import { useNavigate, useRouter } from "@tanstack/react-router";

function useBackward() {
	const navigate = useNavigate();
	const router = useRouter();
	const { history } = router;
	const handleBack = (
		pathname?: Parameters<typeof navigate>[0]["to"],
		options?: Omit<Parameters<typeof navigate>[0], "to">,
	) => {
		if (history.canGoBack()) {
			return history.back();
		}
		return navigate({
			...options,
			resetScroll: true,
			to: pathname ?? "/",
		});
	};
	return handleBack;
}

export default useBackward;
